<template>
  <div id="productListPage" >
    <NavBar class="overflow-y-hidden" :active="activeNav"/>
        <div class="row"  >
      <div class="col-12 col-md-8 col-lg-6 mx-auto">
    <v-main class="overflow-hidden">
      <div class="has-footer-payments">
        <div class="container-fluid">
          <ProductsOrStoreCategories :categories="productsCategories"  :isOnline="$route.query.isOnline"/>

          <div class="row ">
            <div class="col col-md-auto pt-0 pl-0">
              <v-text-field
                  append-icon="far fa-magnifying-glass"
                  class="rounded-lg"
                  dense
                  clearable
                  v-model="searchKeyWord"
                  @click:clear="clearSearchResult"
                  @keydown="search"
                  flat
                  hide-details
                  solo>
              </v-text-field>
            </div>
            <div class="col-auto pt-0 px-0">
              <v-btn id="category" icon @click="category = true">
                <i class="fa-solid fa-list-check fa-xl"></i>
              </v-btn>
            </div>
            <div v-if="hasFilter" class="col-auto pt-0 px-0">
              <v-btn icon @click="openFilterBox">
                <i class="fa-solid fa-filter fa-xl"></i>
              </v-btn>
            </div>
            <div class="col-auto pt-0 px-0">
              <v-btn icon @click="openSortBox">
                <i class="fa-solid fa-sliders fa-xl"></i>
              </v-btn>
            </div>
          </div>

          <div class="row">
                    <h1 class="col-8 primary-text col-12">{{title }}</h1>
            <div v-if="products=== null" class="col-12  text-center">
              <div><i class="fa-light fa-face-frown-slight fa-3x grey--text"></i></div>
              <div class="mt-2">
                موردی یافت نشد
              </div>

            </div>
            <div v-for="item in products" :key="item.id" class="col-12 py-1">
              <ProductListsCard :item="item"/>
            </div>
          </div>
        </div>
        <div>
          <PaymentsFooter :current-page="'products'" :is-in-online-payment="$route.query.isOnline"/>
        </div>
        <div id="sliderMenu" class="border-bottom mx-1">
          <div id="slideMenuWarpper">
            <div id="darkOverlay" class="dark-overlay"></div>
            <nav id="example-menu2" class="slide-menu rounded-l-lg">
              <v-btn icon @click="closeDrawer">
                <i class="fa-solid fa-circle-xmark fa-xl"></i>
              </v-btn>
              <div class="row mx-2 light-gray-bg  rounded-lg">
                <div class="col-3 "><i class="fa-solid fa-list-check fa-xl"></i></div>
                <div class="col-9 "> دسته محصولات</div>
              </div>
              <ul id="categoryNavDrawer">
                <li v-for="(Item,index) in items" :key="index">
                  <a class="py-2" href="#"
                     @click="checkToGoToProductList(Item.Children,Item.Item.ProductCategoryID)">{{ Item.Item.Name }}</a>
                  <ul v-if="Item.Children.length > 0">
                    <li v-for="(child,i) in Item.Children" :key="i">
                      <a class="py-2" href="#"
                         @click="checkToGoToProductList(child.Children,child.Item.ProductCategoryID)">
                        {{ child.Item.Name }}
                      </a>
                      <ul v-if="child.Children.length > 0">
                        <li v-for="(child2,j) in child.Children" :key="j">
                          <a class="py-2" href="#"
                             @click="checkToGoToProductList(child2.Children,child2.Item.ProductCategoryID)">
                            {{ child2.Item.Name }}
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div id="sortBox" class="sort-box bg-white p-2">
          <v-btn icon @click="closeSortBox">
            <i class="fa-solid fa-circle-xmark fa-xl"></i>
          </v-btn>
          <div class="row mx-2 light-gray-bg  rounded-lg ">
            <div class="col-3 "><i class="fa-solid fa-sliders fa-xl"></i></div>
            <div class="col-9 ">مرتب سازی</div>
          </div>
          <v-radio-group v-model="filterSelected">
            <v-radio
                v-for="(item,i) in sortItems"
                :key="i+1"
                :label="item"
                :value="i+1"
                @change="sort(i+1)"
            ></v-radio>
          </v-radio-group>
        </div>
        <div id="filter" class="filter-box bg-white p-2">
          <v-btn icon @click="closeFilterBox">
            <i class="fa-solid fa-circle-xmark fa-xl"></i>
          </v-btn>
          <div class="row mx-2 light-gray-bg  rounded-lg ">
            <div class="col-3 "><i class="fa-solid fa-filter fa-xl"></i></div>
            <div class="col-9 ">فیلتر محصولات</div>
          </div>


            <div v-for="(item,index) in filterItems" :key="index" class="row mx-1">

              <div class="col-12 pb-0 pr-1"> {{ item.ProductCategoryDetailName }}</div>
              <div class="col-10 px-0 py-1 ">
                <v-autocomplete
                    v-if="item.TypeProductCategoryDetail === 3"
                    v-model="filterId[item.ProductCategoryDetailID]"
                    background-color="secondary"
                    :items="(item.ProductCategoryDetaiValue)"
                    dense
                    flat
                    hide-details
                    solo></v-autocomplete>
                <v-autocomplete
                    v-if="item.TypeProductCategoryDetail === 1"
                    v-model="filterId[item.ProductCategoryDetailID]"
                    :items="booleanFilter(item.ProductCategoryDetaiValue)"
                    background-color="secondary"
                    dense
                    hide-details
                    solo
                    flat></v-autocomplete>
              </div>
              <div class="col-2 pr-1 align-self-center py-1">
                <v-btn icon @click="closeFilterBox(item.ProductCategoryDetailID)">
                  <i class="fa-solid fa-arrow-left fa-xl"></i>
                </v-btn>
              </div>
            </div>

        </div>
      </div>
    </v-main>
        </div>
    </div>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
  </div>
</template>

<script>
import ProductListsCard from "@/components/ProductListsCard";
import ProductsOrStoreCategories from "@/components/ProductsOrStoreCategories";
import PaymentsFooter from "@/components/PaymentsFooter";
import NavBar from "@/components/NavBar";

let menu = null;

export default {
  name: "ProductsList",
  metaInfo: {
    title: 'ایوان خانه- محصولات',
  },
  components: {NavBar, PaymentsFooter, ProductListsCard, ProductsOrStoreCategories,},
  data: () => ({
    productsCategories: [],
    productsCategoriesLoading: true,
    products: [],
    items: [],
    category: false,
    showLoaderDialog: false,
    filterSelected: 1,
    sortItems: ['پیش فرض', 'جدیدترین', 'کمترین قیمت', 'بیشترین قیمت' ,'بیشترین فروش', 'بیشترین بازدید', 'محبوب ترین'],
    isOnline: null,
    filterItems: [],
    hasFilter: false,
    filterId: {},
    categoryID: null,
    userSelectedFilter:false,
    userSelectedTypeSort:false,
    typeSortSelected: null,
    offsetTop: 0,
    searchKeyWord:null,
    activeNav:null,
    title:null

  }),
  mounted() {
    this.categoryID = this.$route.query.ProductCategoryID
    this.initData()
    this.isOnline = this.$route.query.isOnline
    if(this.$route.query.type !==undefined) {
      this.title = (this.$route.query.type).replaceAll('_', ' ')
    }else {
      this.title = this.$route.query.Name
    }
    this.getProductCategories()
    this.getProducts()
    this.getFilterData()
    if(this.isOnline === 'true'){
      this.activeNav ='online'
    }else {
      this.activeNav ='offline'
    }

  },
  watch: {
    '$route.query'() {
      this.categoryID = this.$route.query.ProductCategoryID
      this.title = this.$route.query.Name
      this.getProducts();
      this.getFilterData()
    },
  },
  methods: {
      booleanFilter(type) {
      for (let i = 0; i < type.length; i++) {
        if (type[i] === "true") {
          type[i] = 'بله'
        } else if (type[i] === "false") {
          type[i] = 'خیر'
        }
      }
      return type
    },
    initData() {
      let requestOptions = {
        method: 'POST',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/AllProductCategoryApiV2", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.items = JSON.parse(result)
            setTimeout(function () {
              new window.SlideMenu(document.getElementById('example-menu2'), {
                position: "right",
                showBackLink: true,
                submenuLinkAfter: '<i class="fa-solid fa-arrow-left"></i>',
              });

              let myAnchor = document.getElementById("category");
              myAnchor.onclick = function () {
                menu = document.getElementById('example-menu2')._slideMenu;
                menu.toggle();
              }

              let menuElement = document.getElementById('example-menu2');
              menuElement.addEventListener('sm.open', function () {
                document.body.classList.toggle('slide-menu-opened');
              });

              menuElement.addEventListener('sm.close', function () {
                document.body.classList.toggle('slide-menu-opened');
              });


              let overLay = document.getElementById("darkOverlay");
              overLay.onclick = function () {
                const menu = document.getElementById('example-menu2')._slideMenu;
                menu.close();
              }
            }, 100)

          })
          .catch(error => console.log('error', error));
    },
    closeDrawer() {
      menu.close();
    },
    openSortBox() {
      document.getElementById('sortBox').classList.add('open')
    },
    closeSortBox() {
      document.getElementById('sortBox').classList.remove('open')

    },
    openFilterBox() {
      document.getElementById('filter').classList.add('open')
    },
    closeFilterBox(id) {
      document.getElementById('filter').classList.remove('open')
      this.categoryID =id
      this.userSelectedFilter= true
      this.getProducts()
    },
    checkToGoToProductList(child, id) {
      if (child.length === 0) {
        const menu = document.getElementById('example-menu2')._slideMenu;
        menu.close();
        document.body.classList.remove('slide-menu-opened');
        this.goToProductList(id)
      }
    },
    goToProductList(id) {
      this.$router.push({path: 'ProductsList', query: {isOnline:this.isOnline,ProductCategoryID: id}})

    },
    getProductCategories() {
      let requestOptions = {
        method: 'POST',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/AllProductCategoryApi", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            let list = json.list.filter(x => x.IsActive === true);
            for(let i=0 ;i<list.length ;i++){
              list[i].id = list[i]. ProductCategoryID
            }
            this.productsCategories =list
            this.productsCategoriesLoading = false;
          })
          .catch(error => console.log('error', error));
    },
    getProducts() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("IsOnlineVendor", this.isOnline);
      if (this.categoryID !== undefined) {
        urlencoded.append("ProductCategoryID",this.$route.query.ProductCategoryID);
      }
      if (this.$route.query.type !== undefined && this.$route.query.type !== 'بیشترین_فروش'&& this.$route.query.type !== 'جدیدترین_ها') {
        urlencoded.append("TypeVendorProduct", this.$route.query.type);
      }else if(this.$route.query.type === 'بیشترین_فروش'   ){
        urlencoded.append("TypeSearchEngineSort",5);
      }else if(this.$route.query.type === 'جدیدترین_ها'){
        urlencoded.append("TypeSearchEngineSort",2);

      }
      if (this.searchKeyWord !== null && this.searchKeyWord !== '') {
        urlencoded.append("KeyWord",this.searchKeyWord);
      }
      if(this.userSelectedFilter === true){
        let selectedFilter = this.filterId
        for (let filter in selectedFilter) {
          if (selectedFilter[filter] !== 'همه') {
            if (selectedFilter[filter] === 'بله') {
              urlencoded.append('productcategorydetailname-' + filter,true);
            } else if (selectedFilter[filter] === 'خیر') {
              urlencoded.append('productcategorydetailname-' + filter,false);
            } else {
              urlencoded.append('productcategorydetailname-' + filter,selectedFilter[filter]);
            }
          }
        }
      }
      if(this.userSelectedTypeSort === true){
        urlencoded.append("TypeSearchEngineSort",this.typeSortSelected);
      }



      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "SearchEngine/_ListProduct", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              let products = JSON.parse(result);
              for (let i = 0; i < products.length; i++) {
                products[i].tip = products[i].VendorProductTipViewModels[0]

                let voteArr = products[i].VoteViewModel

                let num = voteArr.length
                let sumVote = 0
                for (let j = 0; j < voteArr.length; j++) {
                  sumVote += voteArr[j].Rate
                }
                let avg = sumVote / num;
                if (avg > 0) {
                  products[i].avgVote = sumVote / num
                } else {
                  products[i].avgVote = 0
                }
                this.products = products;
              }
            } else {
              this.products = null
            }
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },
    getFilterData() {
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      if (this.categoryID !== undefined) {
        urlencoded.append("ProductCategoryID",this.categoryID);
      }


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/LoadFiltersApi", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            if (json.length === 0) {
              this.hasFilter = false
            } else {
              this.hasFilter = true
            }
            for (let i = 0; i < json.length; i++) {
              json[i].ProductCategoryDetaiValue.unshift('همه')
            }
            this.filterItems = json
          }).catch(error => console.log('error', error));
    },
    sort(i){
      this.userSelectedTypeSort= true
      this.typeSortSelected = i
      this.closeSortBox()
      this.getProducts()
    },
    search(e) {
      if (e.keyCode === 13) {
        this.getProducts()
      }
    },
    clearSearchResult(){
      this.searchKeyWord =null
      this.getProducts()
    }
  }
}
</script>

